document.addEventListener("BSS:changeVariant", e=> {
  setTimeout(()  => {
    const productForm = document.querySelector("[bss-b2b-main-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
  }, 500)
});

async function addCollectionPriceAttributes(config) {
    if (!window.BSS_B2B.productMap) {
        window.BSS_B2B.productMap = new Map();
    }

    const productCache = window.BSS_B2B.productMap;
    const collectionProducts = window.BSS_B2B?.shopData?.collection || [];

    const cards = Array.from(document.querySelectorAll(config.selectorCard));

    const tasks = cards.map(async (card) => {
        const link = card.querySelector('a');
        const href = link?.getAttribute('href');
        const handle = href?.split('/products/')[1]?.split('?')[0];
        const priceEl = card.querySelector(config.selectorPrice);

        if (!handle || !priceEl || priceEl.hasAttribute('bss-b2b-product-id')) return;

        const productFromData = collectionProducts.find((p) => p.handle === handle);
        if (productFromData) {
            apply(priceEl, productFromData);
            return;
        }

        if (productCache.has(handle)) {
            apply(priceEl, productCache.get(handle));
            return;
        }

        try {
            const res = await fetch(`/products/${handle}.js`);
            const product = res.ok ? await res.json() : null;
            if (!product) return;
            productCache.set(handle, product);
            apply(priceEl, product);
        } catch (e) {
            window.BSS_B2B.logger?.warn?.(`[BSS B2B] fetch error: ${handle}`, e);
        }
    });

    await Promise.all(tasks);

    function apply(el, product) {
        el.setAttribute('bss-b2b-product-id', product.id);
        el.setAttribute('bss-b2b-variant-id', product.variants?.[0]?.id || '');
        el.setAttribute('bss-b2b-product-price', '');
        el.setAttribute('bss-b2b-collection-element', '');
    }
}

 document.addEventListener("BSS:changeVariant", e=> {
  setTimeout(()  => {
    const productForm = document.querySelector("[bss-b2b-main-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
  }, 500)
});

async function addCollectionPriceAttributes(config) {
    if (!window.BSS_B2B.productMap) {
        window.BSS_B2B.productMap = new Map();
    }

    const productCache = window.BSS_B2B.productMap;
    const collectionProducts = window.BSS_B2B?.shopData?.collection || [];

    const cards = Array.from(document.querySelectorAll(config.selectorCard));

    const tasks = cards.map(async (card) => {
        const link = card.querySelector('a');
        const href = link?.getAttribute('href');
        const handle = href?.split('/products/')[1]?.split('?')[0];
        const priceEl = card.querySelector(config.selectorPrice);

        if (!handle || !priceEl || priceEl.hasAttribute('bss-b2b-product-id')) return;

        const productFromData = collectionProducts.find((p) => p.handle === handle);
        if (productFromData) {
            apply(priceEl, productFromData);
            return;
        }

        if (productCache.has(handle)) {
            apply(priceEl, productCache.get(handle));
            return;
        }

        try {
            const res = await fetch(`/products/${handle}.js`);
            const product = res.ok ? await res.json() : null;
            if (!product) return;
            productCache.set(handle, product);
            apply(priceEl, product);
        } catch (e) {
            window.BSS_B2B.logger?.warn?.(`[BSS B2B] fetch error: ${handle}`, e);
        }
    });

    await Promise.all(tasks);

    function apply(el, product) {
        el.setAttribute('bss-b2b-product-id', product.id);
        el.setAttribute('bss-b2b-variant-id', product.variants?.[0]?.id || '');
        el.setAttribute('bss-b2b-product-price', '');
        el.setAttribute('bss-b2b-collection-element', '');
    }
}

let debounceTimer = null;
const config = {
    selectorCard: '.dfd-card.dfd-card-preset-product.dfd-card-type-product', 
    selectorPrice: '.dfd-card-price'
}
let checkGlobalOpenSearch = false;
function handleScroll() {
  const target = document.querySelector('.dfd-content');
  let debounceTimer1 = null;
  const debounceDelay = 1000;

  const observer1 = new MutationObserver((mutationsList) => {
    clearTimeout(debounceTimer);

    debounceTimer1 = setTimeout(async() => {
      await addCollectionPriceAttributes(config);
      BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
    }, debounceDelay);
  });

  observer1.observe(target, {
    attributes: true,
    childList: true,
    subtree: true, 
    characterData: true
  });
}
document.addEventListener('input', (e) => {
  const target = e.target;
  if (target && target.classList.contains('dfd-searchbox-input')) {
    if(!checkGlobalOpenSearch) {
      checkGlobalOpenSearch = true;
      handleScroll();
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async() => {
       await addCollectionPriceAttributes(config);
      BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
    }, 1000);
  }
}, true);

document.addEventListener('click', (e) => {
  const target = e.target;
if(target && target.classList.contains("searchButton")){
    setTimeout(async() => {
      await addCollectionPriceAttributes(config);
      BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
    }, 2000)
  }
}, true);

document.addEventListener("DOMContentLoaded", async(e) => {
  setTimeout(async() => {
      await addCollectionPriceAttributes(config);
      BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 4000)
})



